export const successMessages = {
  projectChangesSaved: 'Project changes saved',
  projectCreated: 'Project created',
  userAdded: 'User added',
  userChangesSaved: 'User changes saved',
  userDeleted: 'User deleted',
  assignmentTimeAdded: 'Assignment time added',
  assignmentTargetDateAdded: 'Assignment target date added',
  profileChangesSaved: 'Profile changes saved',
  assignmentSubmitted: 'Assignment submitted',
  aiAutoStarted: 'Training started',
};
